export var SapAgentStatus;
(function (SapAgentStatus) {
    SapAgentStatus["SAP_AGENT_STATUS_ONLINE"] = "ONLINE";
    SapAgentStatus["SAP_AGENT_STATUS_OFFLINE"] = "OFFLINE";
    SapAgentStatus["SAP_AGENT_STATUS_ENROLLING"] = "ENROLLING";
})(SapAgentStatus || (SapAgentStatus = {}));
